var _circle, _circle2, _circle3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTokenNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "#0F1021"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "url(#paint0_radial_1326_971)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    stroke: "#464B8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2573 34.96L17.3379 29.16L27.2559 43L37.1833 29.16L27.2532 34.96H27.2573ZM27.4081 11L17.4861 27.2973L27.4068 33.1027L37.3275 27.3027L27.4081 11Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1326_971",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5 27.5) rotate(1.14576) scale(137.527 82.5165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5349CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101122",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTokenNetwork);
export default __webpack_public_path__ + "static/media/icon_token_network.b162248582e6517de6be008e9178a962.svg";
export { ForwardRef as ReactComponent };